module.exports = __webpack_public_path__ + "img/partners-top-xs-drawing.e9b31ace.svg";